module.exports = __webpack_public_path__ + "static/fipcmintorganicmain-12c44e1bf3cb5d30afc0945069db03a6.jpeg";